(function (angular) {
    'use strict';

    angular.module('inboundRules')
        .component('inboundRule', {
            bindings: {
                inboundRule: '=',
                settings: '<',
                deleteRule: '&',
                inboundIndex: '<',
                saveRule: '&'
            },
            controller: ['$uibModal', function ($uibModal) {
                var ctrl = this;

                ctrl.channelsConfiguration = [{
                    id: "sms",
                    name: "SMS",
                    logo: "",
                    inboundDisplay: "Number",
                    inboundLabel: "Select number",
                    inbound: {
                        name: "inboundNumbers",
                        id: "number",
                        label: "name"
                    }
                }, {
                    id: "fbMessenger",
                    name: "FB Messenger",
                    logo: "",
                    inboundDisplay: "Page",
                    inboundLabel: "Select page",
                    inbound: {
                        name: "fbPages",
                        id: "pageId",
                        label: "name"
                    }
                }, {
                    id: "appMessaging",
                    name: "App Messaging",
                    logo: "",
                    inboundDisplay: "Team",
                    inboundLabel: "Select team",
                    inbound: {
                        name: "teams",
                        id: "id",
                        label: "name"
                    }
                }, {
                    id: "email",
                    name: "Email",
                    logo: "",
                    inboundDisplay: "Mailbox"
                }];

                ctrl.optOptions = [{
                    id: "out",
                    name: "Opt Out"
                }, {
                    id: "in",
                    name: "Opt In"
                }];

                //as components are retarded and try to run code before having data we have to use onInit
                ctrl.$onInit = function () {
                    ctrl.channelsConfiguration = ctrl.channelsConfiguration.filter(function (config) {
                        return ctrl.settings.availableChannels.filter(function (availableChannel) {
                            return availableChannel.id == config.id;
                        }).length > 0;
                    });

                    ctrl.actionsConfigurationWithoutChat = ctrl.settings.actionsConfiguration.filter(function (actionConfiguration) {
                        return actionConfiguration.id != 'startChat';
                    });

                    ctrl.availableTeams = _.memoize(function (channel, inbound) {
                        return ctrl.settings.inboundOptions.teams.filter(function (team) {
                            var check = true;
                            if (channel == 'appMessaging') {
                                check = inbound != team.id;
                            }
                            return check && ctrl.settings.inboundOptions.teams.filter(function (configTeam) {
                                return configTeam.teamId == team.id && configTeam.channels[channel];
                            }).length > 0;
                        });
                    });
                };


                ctrl.save = function () {
                    if (ctrl.isValid()) {
                        ctrl.saveRule({ index: ctrl.inboundIndex });
                    }
                   
                };

                ctrl.delete = function () {
                    ctrl.deleteRule({ index: ctrl.inboundIndex });
                };

                ctrl.channelChange = function (rule) {
                    rule.inbound = '';
                    ctrl.inboundChange(rule);
                };

                ctrl.inboundChange = function (rule) {
                    if (ctrl.availableActions(rule).filter(function (action) {
                        return action.id == rule.action;
                    }).length === 0) {
                        delete rule.action;
                    }
                };

                function actionIsDefined() {
                    return ctrl.inboundRule.actionData &&(ctrl.inboundRule.actionData.messageParts &&
                        ctrl.inboundRule.actionData.messageParts.length > 0 || ctrl.inboundRule.actionData.profileUpdate && ctrl.inboundRule.actionData.profileUpdate.length > 0);
                }

                ctrl.isValid = function isValid() {
                    return ctrl.inboundRule.channel &&
                        ctrl.inboundRule.action &&
                        ctrl.inboundRule.inbound &&
                        actionIsDefined();
                };

                ctrl.availableActions = function (rule) {
                    if (rule.channel == "fbMessenger" || ctrl.checkIfUsed(rule) || ctrl.availableTeams(rule.channel, rule.inbound).length === 0) {
                        return ctrl.actionsConfigurationWithoutChat;
                    }
                    return ctrl.settings.actionsConfiguration;
                };

                ctrl.checkIfUsed = function (inboundRule) {
                    return ctrl.settings.usedChannels && ctrl.settings.usedChannels[inboundRule.channel] ? ctrl.settings.usedChannels[inboundRule.channel].includes(inboundRule.inbound) : false;
                };

                ctrl.updateProperty = function updateProperty(inboundRule) {
                    var modalInstance = $uibModal.open({
                        templateUrl: 'components/automation/inboundRules/settings/templates/updatePropertyModal.html',
                        size: 'md',
                        resolve: {
                            inboundRule: function () { return inboundRule; },
                            settings: function () { return ctrl.settings; }
                        },
                        controller: 'updatePropertyModalCtrl'
                    });
                    modalInstance.result.then(function (result) {
                        ctrl.inboundRule.actionData.profileUpdate[0] = result;
                    });
                };


                ctrl.createMessage = function createMessage(inboundRule) {
                    var modalInstance = $uibModal.open({
                        templateUrl: 'components/automation/inboundRules/settings/templates/createMessageModal.html',
                        size: 'lg',
                        resolve: {
                            inboundRule: function () { return inboundRule; },
                            settings: function () { return ctrl.settings; }
                        },
                        controller: 'createMessageModalCtrl'
                    });
                    modalInstance.result.then(function (result) {
                        ctrl.inboundRule = result;
                    });
                };

                ctrl.resetActionData = function (inboundRule) {
                    inboundRule.actionData = {};

                    ctrl.settings.actionsConfiguration.forEach(function (actionSettings) {
                        if (actionSettings.id == inboundRule.action) {
                            actionSettings.options.forEach(function (option) {
                                if (option.type == 'optEnum') {
                                    inboundRule.actionData[option.name] = 'out';
                                }
                                else if (option.type == 'array') {
                                    inboundRule.actionData[option.name] = [];
                                }
                                else {
                                    inboundRule.actionData[option.name] = '';
                                }
                            });
                        }
                    });
                    
                };

                ctrl.addVariable = function (inboundRule) {
                    if (!inboundRule.actionData) {
                        inboundRule.actionData = {};
                    }
                    if (!inboundRule.actionData.profileUpdate) {
                        inboundRule.actionData.profileUpdate = [];
                    }
                    inboundRule.actionData.profileUpdate.push({});
                };

                ctrl.deleteVariable = function (inboundRule, type) {
                    switch (type) {
                        case 'profileUpdate':
                            inboundRule.actionData.profileUpdate=[];
                            break;
                        case 'messageParts':
                            inboundRule.actionData.messageParts=[];

                    }

                };
            }],
            templateUrl: './components/automation/inboundRules/settings/templates/component.inboundRule.html'
        });
})(window.angular);